import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core/styles";
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
	Cell,
} from "recharts";

import { i18n } from "../../translate/i18n";

const QueuesChart = ({ queues }) => {
	const theme = useTheme();

	if (!queues?.length) {
		return (
			<Paper style={{ padding: 16, height: "100%" }}>
				<Typography variant="h6" color="primary" gutterBottom>
					{i18n.t("dashboard.queues.title")}
				</Typography>
				<Typography color="textSecondary" align="center" style={{ padding: 24 }}>
					{i18n.t("dashboard.queues.empty")}
				</Typography>
			</Paper>
		);
	}

	const data = queues.map(q => ({
		name: q.name,
		count: q.count,
		color: q.color || theme.palette.primary.main,
	}));

	return (
		<Paper style={{ padding: 16, height: "100%" }}>
			<Typography variant="h6" color="primary" gutterBottom>
				{i18n.t("dashboard.queues.title")}
			</Typography>
			<ResponsiveContainer width="100%" height={280}>
				<BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 40 }}>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis
						dataKey="name"
						angle={-25}
						textAnchor="end"
						interval={0}
						height={60}
						tick={{ fontSize: 11 }}
					/>
					<YAxis allowDecimals={false} />
					<Tooltip />
					<Bar dataKey="count" name={i18n.t("dashboard.queues.tickets")}>
						{data.map((entry, index) => (
							<Cell key={index} fill={entry.color} />
						))}
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</Paper>
	);
};

export default QueuesChart;
